import { Navigate, NavLink, Route, Routes } from "react-router";
import { AuditTab } from "./admin/AuditTab";
import { ChatsTab } from "./admin/ChatsTab";
import { SettingsTab } from "./admin/SettingsTab";
import { UsersTab } from "./admin/UsersTab";

/**
 * Администрирование — только роль admin. Справочники и перевозчики вынесены в /directory (доступны логистам),
 * профиль — в /profile. Ставки с авторами показываются на карточке лота (блок «Все ставки (админ)»).
 * Ещё не сделано: группы рассылки, статистика.
 */
const TABS = [
  { path: "users", label: "Пользователи" },
  { path: "chats", label: "Чаты" },
  { path: "settings", label: "Настройки" },
  { path: "audit", label: "Журнал" },
] as const;

export function AdminPage() {
  return (
    <>
      <div className="page-header">
        <h1>Администрирование</h1>
      </div>
      <nav className="tabs">
        {TABS.map((t) => (
          <NavLink key={t.path} to={`/admin/${t.path}`}>
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Routes>
        <Route index element={<Navigate to="/admin/users" replace />} />
        <Route path="users" element={<UsersTab />} />
        <Route path="chats" element={<ChatsTab />} />
        <Route path="settings" element={<SettingsTab />} />
        <Route path="audit" element={<AuditTab />} />
        <Route path="*" element={<Navigate to="/admin/users" replace />} />
      </Routes>
    </>
  );
}
